import {
  Select,
  MainButton,
  FormFeedBack,
  OverlineTitle,
  formatDataToLabelValue,
  convertEventSelectToTarget,
} from '@repo/ui';
import React from 'react';
import { Card, Col, Input, Label, Row } from 'reactstrap';

import { AppProfessionalSettingsSection } from '../../entity-form-sections/app-professional-settings-section';

import './styles.scss';
import { FormikValues } from 'formik';

const emptySsoProvider = {
  ssoProviderId: null,
  domain: '',
  clientId: '',
  tenantId: '',
  secretKey: '',
};

interface IProps {
  imgFileDocx: string;
  fileSelected: string;
  marginYButton: string;
  listSsoProviders: any;
  validation: FormikValues;
  listInsuranceCompanies: any;
  setDeleteTce: (value: boolean) => void;
  setFileSelected: (fileName: string) => void;
  fileInputRef: React.RefObject<HTMLInputElement>;
  handleDeleteFile: (e: React.MouseEvent) => void;
}

export const SettingForm = ({
  setDeleteTce,
  setFileSelected,
  handleDeleteFile,
  validation,
  imgFileDocx,
  fileInputRef,
  fileSelected,
  marginYButton,
  listInsuranceCompanies,
  listSsoProviders,
}: IProps) => {
  const ssoProviders: any[] = Array.isArray(
    validation?.values?.setting?.sso?.providers,
  )
    ? validation.values.setting.sso.providers
    : [];
  return (
    <>
      <Row>
        <div className="mt-2">
          <OverlineTitle title="Termo de compromisso de estágio" />
        </div>

        <Col md={6} className={`${marginYButton}`}>
          <Label htmlFor="insuranceCompanyId" className="form-label">
            Seguradora do TCE
          </Label>

          <Select
            isClearable
            id="insuranceCompanyId"
            name="tce.insuranceCompanyId"
            placeholder=""
            value={validation?.values?.tce?.insuranceCompanyId}
            onChange={(e: any) =>
              validation.handleChange(
                convertEventSelectToTarget('tce.insuranceCompanyId', e),
              )
            }
            onBlur={validation.handleBlur}
            options={formatDataToLabelValue(
              listInsuranceCompanies as never,
              'id',
              'name',
            )}
          />
        </Col>
        <Col md={6} className={`${marginYButton}`}>
          <Label htmlFor="policy" className="form-label">
            Número da Apólice
          </Label>
          <Input
            id="policy"
            type="text"
            name="tce.policy"
            className="form-control"
            value={validation?.values?.tce?.policy}
            onChange={validation.handleChange}
          />
        </Col>
        <Col md={6} className={`${marginYButton}`}>
          <Label htmlFor="rescissionTermModel" className="form-label">
            Modelo de Termo de Rescisão
          </Label>
          <div className="file-input-wrapper">
            <Input
              style={{ borderRadius: '5px 0px 0px 5px' }}
              id="rescissionTermModel"
              innerRef={fileInputRef}
              type="file"
              accept=".doc,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              name="tce.rescissionTermModel"
              invalid={
                validation?.touched?.tce?.rescissionTermModel &&
                !!validation?.errors?.tce?.rescissionTermModel
              }
              onBlur={validation?.handleBlur}
              onChange={(e) => {
                const { files } = e.target;
                setFileSelected(files[0]?.name);
                if (files) {
                  setDeleteTce(false);
                  validation.setFieldValue('tce.rescissionTermModel', files[0]);
                }
              }}
            />
          </div>
          <FormFeedBack
            error={validation?.errors?.tce?.rescissionTermModel as any}
            isInvalid={
              !!(
                validation?.touched?.tce?.rescissionTermModel &&
                validation?.touched?.tce?.rescissionTermModel
              )
            }
          />

          {validation.values.tce?.rescissionTermModel && (
            <Card
              className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
              key="saved-photo"
            >
              <div className="p-2">
                <Row className="align-items-center">
                  <Col className="col-auto">
                    <img
                      data-dz-thumbnail=""
                      height="80"
                      className="avatar-sm rounded bg-light"
                      alt="Saved Photo"
                      src={imgFileDocx}
                    />
                  </Col>
                  <Col>
                    <p className="mb-0">
                      <strong>Modelo de Termo de Rescisão</strong>
                    </p>
                  </Col>
                  <Col className="col-auto">
                    <button
                      type="button"
                      className="btn btn-danger me-1 btn-sm"
                      onClick={(e) => {
                        handleDeleteFile(e);
                      }}
                    >
                      <i className="ri-close-line"></i>
                    </button>

                    {!fileSelected && (
                      <button
                        type="button"
                        className="btn btn-primary btn-sm"
                        onClick={() => {
                          const a = document.createElement('a');
                          a.href = validation.values.tce?.rescissionTermModel;
                          a.download = `Modelo de Termo de Rescisão - ${validation.values?.tradeName}`;
                          a.click();
                        }}
                      >
                        <i className="ri-file-download-line"></i>
                      </button>
                    )}
                  </Col>
                </Row>
              </div>
            </Card>
          )}
        </Col>
      </Row>
      <Row>
        <Col className="" md={12}>
          <div className="mt-2">
            <OverlineTitle title="Configuração na organização" />
          </div>
          <Row className="mt-2">
            <Col md={12}>
              <div className="form-check mb-3">
                <Input
                  id="ssoEnabled"
                  type="checkbox"
                  name="setting.sso.enabled"
                  className="form-check-input"
                  onBlur={validation.handleBlur}
                  onChange={(e) => {
                    const isEnabled = e.target.checked;
                    validation.setFieldValue('setting.sso.enabled', isEnabled);
                    if (!isEnabled) {
                      validation.setFieldValue('setting.sso.providers', []);
                      validation.setFieldTouched('setting.sso', false, false);
                    } else if (!ssoProviders.length) {
                      validation.setFieldValue('setting.sso.providers', [
                        { ...emptySsoProvider },
                      ]);
                    }
                  }}
                  checked={validation?.values?.setting?.sso?.enabled}
                />
                <label className="form-check-label" htmlFor="ssoEnabled">
                  Configurar SSO
                </label>
              </div>
            </Col>
          </Row>

          {validation?.values?.setting?.sso?.enabled && (
            <>
              {ssoProviders.map((provider, index) => {
                const providerErrors =
                  (validation?.errors?.setting?.sso?.providers as any)?.[
                    index
                  ] || {};
                const providerTouched =
                  (validation?.touched?.setting?.sso?.providers as any)?.[
                    index
                  ] || {};
                const basePath = `setting.sso.providers[${index}]`;

                return (
                  <Row
                    key={index}
                    className={index > 0 ? 'border-top pt-3 mt-3' : ''}
                  >
                    <Col md={4} className={`${marginYButton}`}>
                      <Label
                        htmlFor={`${basePath}.ssoProviderId`}
                        className="form-label"
                      >
                        Provedor
                      </Label>
                      <Select
                        isClearable
                        id={`${basePath}.ssoProviderId`}
                        name={`${basePath}.ssoProviderId`}
                        placeholder=""
                        value={provider.ssoProviderId}
                        onChange={(e) =>
                          validation.handleChange(
                            convertEventSelectToTarget(
                              `${basePath}.ssoProviderId`,
                              e,
                            ),
                          )
                        }
                        onBlur={validation.handleBlur}
                        options={formatDataToLabelValue(
                          listSsoProviders as never,
                          'id',
                          'name',
                        )}
                      />
                      <FormFeedBack
                        error={providerErrors?.ssoProviderId}
                        isInvalid={
                          !!(
                            providerTouched?.ssoProviderId &&
                            providerErrors?.ssoProviderId
                          )
                        }
                      />
                    </Col>

                    <Col md={4} className={`${marginYButton}`}>
                      <Label
                        htmlFor={`${basePath}.domain`}
                        className="form-label"
                      >
                        Domínio
                      </Label>
                      <Input
                        id={`${basePath}.domain`}
                        type="text"
                        name={`${basePath}.domain`}
                        className="form-control"
                        value={provider.domain}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        invalid={
                          !!(providerTouched?.domain && providerErrors?.domain)
                        }
                      />
                      <FormFeedBack
                        error={providerErrors?.domain as any}
                        isInvalid={
                          !!(providerTouched?.domain && providerErrors?.domain)
                        }
                      />
                    </Col>

                    <Col md={4} className={`${marginYButton}`}>
                      <Label
                        htmlFor={`${basePath}.clientId`}
                        className="form-label"
                      >
                        Client ID
                      </Label>
                      <Input
                        id={`${basePath}.clientId`}
                        type="text"
                        name={`${basePath}.clientId`}
                        className="form-control"
                        value={provider.clientId}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        invalid={
                          !!(
                            providerTouched?.clientId &&
                            providerErrors?.clientId
                          )
                        }
                      />
                      <FormFeedBack
                        error={providerErrors?.clientId as any}
                        isInvalid={
                          !!(
                            providerTouched?.clientId &&
                            providerErrors?.clientId
                          )
                        }
                      />
                    </Col>

                    <Col md={4} className={`${marginYButton}`}>
                      <Label
                        htmlFor={`${basePath}.tenantId`}
                        className="form-label"
                      >
                        Tenant ID
                      </Label>
                      <Input
                        id={`${basePath}.tenantId`}
                        type="text"
                        name={`${basePath}.tenantId`}
                        className="form-control"
                        value={provider.tenantId}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        invalid={
                          !!(
                            providerTouched?.tenantId &&
                            providerErrors?.tenantId
                          )
                        }
                      />
                      <FormFeedBack
                        error={providerErrors?.tenantId as any}
                        isInvalid={
                          !!(
                            providerTouched?.tenantId &&
                            providerErrors?.tenantId
                          )
                        }
                      />
                    </Col>

                    <Col md={4} className={`${marginYButton}`}>
                      <Label
                        htmlFor={`${basePath}.secretKey`}
                        className="form-label"
                      >
                        Secret Key
                      </Label>
                      <Input
                        id={`${basePath}.secretKey`}
                        type="password"
                        autoComplete="new-password"
                        name={`${basePath}.secretKey`}
                        className="form-control"
                        value={provider.secretKey}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        invalid={
                          !!(
                            providerTouched?.secretKey &&
                            providerErrors?.secretKey
                          )
                        }
                      />
                      <FormFeedBack
                        error={providerErrors?.secretKey as any}
                        isInvalid={
                          !!(
                            providerTouched?.secretKey &&
                            providerErrors?.secretKey
                          )
                        }
                      />
                      {!!provider.maskedSecretKey && (
                        <small className="text-muted">
                          Chave atual: {provider.maskedSecretKey}. Preencha para
                          substituí-la.
                        </small>
                      )}
                    </Col>

                    <Col
                      md={4}
                      className={`${marginYButton} d-flex align-items-end justify-content-end`}
                    >
                      <button
                        type="button"
                        className="btn btn-danger btn-sm"
                        onClick={() => {
                          const providers = [...ssoProviders];
                          providers.splice(index, 1);
                          validation.setFieldValue(
                            'setting.sso.providers',
                            providers,
                          );
                        }}
                      >
                        <i className="ri-close-line"></i>
                      </button>
                    </Col>
                  </Row>
                );
              })}
              <Row className="mb-3">
                <Col md={12}>
                  <FormFeedBack
                    error={
                      typeof validation?.errors?.setting?.sso?.providers ===
                      'string'
                        ? (validation?.errors?.setting?.sso?.providers as any)
                        : undefined
                    }
                    isInvalid={
                      typeof validation?.errors?.setting?.sso?.providers ===
                      'string'
                    }
                  />
                </Col>
                <Col md={12} className="d-flex justify-content-end">
                  <MainButton
                    onClick={() =>
                      validation.setFieldValue('setting.sso.providers', [
                        ...ssoProviders,
                        { ...emptySsoProvider },
                      ])
                    }
                  >
                    <i className="ri-add-line"></i>
                    <span className="me-2">Adicionar provedor</span>
                  </MainButton>
                </Col>
              </Row>
            </>
          )}
        </Col>
        <Col md={4} className={`${marginYButton}`}>
          <div className="mt-2">
            <OverlineTitle title="Configurações gerais" />
          </div>
          <Row className="align-items-end">
            <Col md={6}>
              <Label
                htmlFor="toleratedDistanceFromInternshipLocation"
                className="form-label"
              >
                Distância tolerada do Local de Estágio (metros)
              </Label>
              <Input
                id="toleratedDistanceFromInternshipLocation"
                type="number"
                name="setting.toleratedDistanceFromInternshipLocation"
                className="form-control"
                value={
                  validation?.values?.setting
                    ?.toleratedDistanceFromInternshipLocation
                }
                onChange={validation.handleChange}
                invalid={
                  validation?.touched?.setting
                    ?.toleratedDistanceFromInternshipLocation &&
                  !!validation?.errors?.setting
                    ?.toleratedDistanceFromInternshipLocation
                }
              />
              <FormFeedBack
                error={
                  validation?.errors?.setting
                    ?.toleratedDistanceFromInternshipLocation as any
                }
                isInvalid={
                  !!(
                    validation?.touched?.setting
                      ?.toleratedDistanceFromInternshipLocation &&
                    validation?.errors?.setting
                      ?.toleratedDistanceFromInternshipLocation
                  )
                }
              />
            </Col>
            <Col md={6}>
              <Label
                htmlFor="timeLimitInDaysToJustifyActivities"
                className="form-label"
              >
                Dias para justificar atividade
              </Label>
              <Input
                min={0}
                id="timeLimitInDaysToJustifyActivities"
                type="number"
                name="setting.timeLimitInDaysToJustifyActivities"
                className="form-control"
                value={
                  validation?.values?.setting
                    ?.timeLimitInDaysToJustifyActivities
                }
                onChange={validation.handleChange}
                invalid={
                  validation?.touched?.setting
                    ?.timeLimitInDaysToJustifyActivities &&
                  !!validation?.errors?.setting
                    ?.timeLimitInDaysToJustifyActivities
                }
              />
              <FormFeedBack
                error={
                  validation?.errors?.setting
                    ?.timeLimitInDaysToJustifyActivities as any
                }
                isInvalid={
                  !!(
                    validation?.touched?.setting
                      ?.timeLimitInDaysToJustifyActivities &&
                    validation?.errors?.setting
                      ?.timeLimitInDaysToJustifyActivities
                  )
                }
              />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md={6}>
              <Label htmlFor="toleranceStartMinutes" className="form-label">
                Tempo de tolerância para iniciar a atividade (minutos)
              </Label>
              <Input
                id="toleranceStartMinutes"
                type="number"
                name="setting.toleranceStartMinutes"
                className="form-control"
                value={validation?.values?.setting?.toleranceStartMinutes}
                onChange={validation.handleChange}
                invalid={
                  validation?.touched?.setting?.toleranceStartMinutes &&
                  !!validation?.errors?.setting?.toleranceStartMinutes
                }
              />
              <FormFeedBack
                error={
                  validation?.errors?.setting?.toleranceStartMinutes as any
                }
                isInvalid={
                  !!(
                    validation?.touched?.setting?.toleranceStartMinutes &&
                    validation?.errors?.setting?.toleranceStartMinutes
                  )
                }
              />
            </Col>
            <Col md={6}>
              <Label htmlFor="toleranceEndMinutes" className="form-label">
                Tempo de tolerância para finalizar a atividade (minutos)
              </Label>
              <Input
                id="toleranceEndMinutes"
                type="number"
                name="setting.toleranceEndMinutes"
                className="form-control"
                value={validation?.values?.setting?.toleranceEndMinutes}
                onChange={validation.handleChange}
                invalid={
                  validation?.touched?.setting?.toleranceEndMinutes &&
                  !!validation?.errors?.setting?.toleranceEndMinutes
                }
              />
              <FormFeedBack
                error={validation?.errors?.setting?.toleranceEndMinutes as any}
                isInvalid={
                  !!(
                    validation?.touched?.setting?.toleranceEndMinutes &&
                    validation?.errors?.setting?.toleranceEndMinutes
                  )
                }
              />
            </Col>
          </Row>

          <Col className="mt-2">
            <div className="form-check mb-3">
              <Input
                id="notifyWppTeacherPendingActivity"
                type="checkbox"
                name="setting.notifyWppTeacherPendingActivity"
                className="form-check-input"
                onBlur={validation.handleBlur}
                onChange={validation.handleChange}
                checked={
                  validation?.values?.setting?.notifyWppTeacherPendingActivity
                }
              />
              <label
                className="form-check-label"
                htmlFor="notifyWppTeacherPendingActivity"
              >
                Notificar profissionais sobre atividades pendentes via WhatsApp
              </label>
            </div>
          </Col>
          <div className="mt-2">
            <OverlineTitle title="Configurações Acadêmicas" />
            <div className="form-check mb-3">
              <Input
                id="appStudentAllowReschedulingMissedActivities"
                type="checkbox"
                name="setting.appStudentAllowReschedulingMissedActivities"
                className="form-check-input"
                onBlur={validation.handleBlur}
                onChange={validation.handleChange}
                checked={
                  validation?.values?.setting
                    ?.appStudentAllowReschedulingMissedActivities
                }
              />
              <label
                className="form-check-label"
                htmlFor="appStudentAllowReschedulingMissedActivities"
              >
                Permitir reposição de horários para faltas
              </label>
            </div>
            <div className="form-check mb-3">
              <Input
                id="allowExternalProfessionalActivityValidation"
                type="checkbox"
                name="setting.allowExternalProfessionalActivityValidation"
                className="form-check-input"
                onBlur={validation.handleBlur}
                onChange={validation.handleChange}
                checked={
                  validation?.values?.setting
                    ?.allowExternalProfessionalActivityValidation
                }
              />
              <label
                className="form-check-label"
                htmlFor="allowExternalProfessionalActivityValidation"
              >
                Habilitar funcionalidade de validação de atividades por
                profissionais externos
              </label>
            </div>
          </div>
        </Col>
        <Col md={4} className={`${marginYButton}`}>
          <div className="mt-2">
            <OverlineTitle title="Configurações app estudante" />
          </div>
          <div className="form-check mb-3">
            <Input
              id="appStudentBlockActivityScheduling"
              type="checkbox"
              name="setting.appStudentBlockActivityScheduling"
              className="form-check-input"
              onBlur={validation.handleBlur}
              onChange={validation.handleChange}
              checked={
                validation?.values?.setting?.appStudentBlockActivityScheduling
              }
            />
            <label
              className="form-check-label"
              htmlFor="appStudentBlockActivityScheduling"
            >
              Bloquear agendamento de atividades pelo Estudante
            </label>
          </div>

          <div className="form-check mb-3">
            <Input
              id="appStudentBlockQrCodeActivityStart"
              type="checkbox"
              name="setting.appStudentBlockQrCodeActivityStart"
              className="form-check-input"
              onBlur={validation.handleBlur}
              onChange={validation.handleChange}
              checked={
                validation?.values?.setting?.appStudentBlockQrCodeActivityStart
              }
            />
            <label
              className="form-check-label"
              htmlFor="appStudentBlockQrCodeActivityStart"
            >
              Bloquear início de atividade por QRCode
            </label>
          </div>

          <div className="form-check mb-3">
            <Input
              id="showFinalActivityEvaluation"
              type="checkbox"
              name="setting.showFinalActivityEvaluation"
              className="form-check-input"
              onBlur={validation.handleBlur}
              onChange={validation.handleChange}
              checked={validation?.values?.setting?.showFinalActivityEvaluation}
            />
            <label
              className="form-check-label"
              htmlFor="showFinalActivityEvaluation"
            >
              Mostrar avaliações ao final das atividades
            </label>
          </div>
          <div className="form-check mb-3">
            <Input
              id="finalActivityEvaluationRequired"
              type="checkbox"
              name="setting.finalActivityEvaluationRequired"
              className="form-check-input"
              onBlur={validation.handleBlur}
              onChange={validation.handleChange}
              checked={
                validation?.values?.setting?.finalActivityEvaluationRequired
              }
            />
            <label
              className="form-check-label"
              htmlFor="finalActivityEvaluationRequired"
            >
              Exigir avaliação final das atividades
            </label>
          </div>
          <div className="form-check mb-3">
            <Input
              id="appStudentStartOnlyToleratedDistance"
              type="checkbox"
              name="setting.appStudentStartOnlyToleratedDistance"
              className="form-check-input"
              onBlur={validation.handleBlur}
              onChange={validation.handleChange}
              checked={
                validation?.values?.setting
                  ?.appStudentStartOnlyToleratedDistance
              }
            />

            <label
              className="form-check-label"
              htmlFor="appStudentStartOnlyToleratedDistance"
            >
              Só permitir iniciar atividades dentro da distância tolerada
            </label>
          </div>
          <div className="form-check mb-3">
            <Input
              id="appStudentFinishOnlyToleratedDistance"
              type="checkbox"
              name="setting.appStudentFinishOnlyToleratedDistance"
              className="form-check-input"
              onBlur={validation.handleBlur}
              onChange={validation.handleChange}
              checked={
                validation?.values?.setting
                  ?.appStudentFinishOnlyToleratedDistance
              }
            />

            <label
              className="form-check-label"
              htmlFor="appStudentFinishOnlyToleratedDistance"
            >
              Só permitir finalizar atividades dentro da distância tolerada
            </label>
          </div>
          <div className="form-check mb-3">
            <Input
              id="appStudentHideTotalWorkload"
              type="checkbox"
              name="setting.appStudentHideTotalWorkload"
              className="form-check-input"
              onBlur={validation.handleBlur}
              onChange={validation.handleChange}
              checked={validation?.values?.setting?.appStudentHideTotalWorkload}
            />
            <label
              className="form-check-label"
              htmlFor="appStudentHideTotalWorkload"
            >
              Ocultar carga horária total
            </label>
          </div>
          <div className="form-check mb-3">
            <Input
              id="appStudentHideWorkloadValidated"
              type="checkbox"
              name="setting.appStudentHideWorkloadValidated"
              className="form-check-input"
              onBlur={validation.handleBlur}
              onChange={validation.handleChange}
              checked={
                validation?.values?.setting?.appStudentHideWorkloadValidated
              }
            />
            <label
              className="form-check-label"
              htmlFor="appStudentHideWorkloadValidated"
            >
              Ocultar carga horária validada
            </label>
          </div>

          <div className="form-check mb-3">
            <Input
              id="appStudentEvaluationField"
              type="checkbox"
              name="setting.appStudentEvaluationField"
              className="form-check-input"
              onBlur={validation.handleBlur}
              onChange={validation.handleChange}
              checked={validation?.values?.setting?.appStudentEvaluationField}
            />
            <label
              className="form-check-label"
              htmlFor="appStudentEvaluationField"
            >
              Avaliação de campo no final da atividade
            </label>
          </div>

          <div className="form-check mb-3">
            <Input
              id="appStudentAllowGenerateQrcodeEvaluation"
              type="checkbox"
              name="setting.appStudentAllowGenerateQrcodeEvaluation"
              className="form-check-input"
              onBlur={validation.handleBlur}
              onChange={validation.handleChange}
              checked={
                validation?.values?.setting
                  ?.appStudentAllowGenerateQrcodeEvaluation
              }
            />
            <label
              className="form-check-label"
              htmlFor="appStudentAllowGenerateQrcodeEvaluation"
            >
              Permitir gerar QRCode de Avaliação
            </label>
          </div>
          <div className="form-check mb-3">
            <Input
              id="appStudentDemandStudentPhotoOnActivityStart"
              type="checkbox"
              name="setting.appStudentDemandStudentPhotoOnActivityStart"
              className="form-check-input"
              onBlur={validation.handleBlur}
              onChange={validation.handleChange}
              checked={
                validation?.values?.setting
                  ?.appStudentDemandStudentPhotoOnActivityStart
              }
            />

            <label
              className="form-check-label"
              htmlFor="appStudentDemandStudentPhotoOnActivityStart"
            >
              Exigir foto do estudante ao iniciar a atividade
            </label>
          </div>
          <div className="form-check mb-3">
            <Input
              id="appStudentDemandStudentPhotoOnActivityEnd"
              type="checkbox"
              name="setting.appStudentDemandStudentPhotoOnActivityEnd"
              className="form-check-input"
              onBlur={validation.handleBlur}
              onChange={validation.handleChange}
              checked={
                validation?.values?.setting
                  ?.appStudentDemandStudentPhotoOnActivityEnd
              }
            />

            <label
              className="form-check-label"
              htmlFor="appStudentDemandStudentPhotoOnActivityEnd"
            >
              Exigir foto do estudante ao finalizar a atividade
            </label>
          </div>
          <div className="form-check mb-3">
            <Input
              id="appStudentDemandFileOnActivityJustification"
              type="checkbox"
              name="setting.appStudentDemandFileOnActivityJustification"
              className="form-check-input"
              onBlur={validation.handleBlur}
              onChange={validation.handleChange}
              checked={
                validation?.values?.setting
                  ?.appStudentDemandFileOnActivityJustification
              }
            />

            <label
              className="form-check-label"
              htmlFor="appStudentDemandFileOnActivityJustification"
            >
              Exigir anexo de arquivo na justificativa da atividade
            </label>
          </div>
          <div className="form-check mb-3">
            <Input
              id="appStudentConsiderAutoFinishedActivityAsMissed"
              type="checkbox"
              name="setting.appStudentConsiderAutoFinishedActivityAsMissed"
              className="form-check-input"
              onBlur={validation.handleBlur}
              onChange={validation.handleChange}
              checked={
                validation?.values?.setting
                  ?.appStudentConsiderAutoFinishedActivityAsMissed
              }
            />

            <label
              className="form-check-label"
              htmlFor="appStudentConsiderAutoFinishedActivityAsMissed"
            >
              Considerar Atividade Finalizada Automaticamente como "Perdida"
            </label>
          </div>

          <div className="form-check mb-3">
            <Input
              id="appStudentConsiderActivityWithLocationBlockAsMissed"
              type="checkbox"
              name="setting.appStudentConsiderActivityWithLocationBlockAsMissed"
              className="form-check-input"
              onBlur={validation.handleBlur}
              onChange={validation.handleChange}
              checked={
                validation?.values?.setting
                  ?.appStudentConsiderActivityWithLocationBlockAsMissed
              }
            />

            <label
              className="form-check-label"
              htmlFor="appStudentConsiderActivityWithLocationBlockAsMissed"
            >
              Considerar Atividade com Bloqueio de Localização como "Perdida"
            </label>
          </div>

          <div className="form-check mb-3">
            <Input
              id="appStudentCanEditInstitutionScheduledActivity"
              type="checkbox"
              name="setting.appStudentCanEditInstitutionScheduledActivity"
              className="form-check-input"
              onBlur={validation.handleBlur}
              onChange={validation.handleChange}
              checked={
                validation?.values?.setting
                  ?.appStudentCanEditInstitutionScheduledActivity
              }
            />

            <label
              className="form-check-label"
              htmlFor="appStudentCanEditInstitutionScheduledActivity"
            >
              Permitir estudante editar atividade agendada pela instituição
            </label>
          </div>

          <div className="form-check mb-3">
            <Input
              id="allowOrganizationQrCodeEvaluationAtActivityEnd"
              type="checkbox"
              name="setting.allowOrganizationQrCodeEvaluationAtActivityEnd"
              className="form-check-input"
              onBlur={validation.handleBlur}
              onChange={validation.handleChange}
              checked={
                validation?.values?.setting
                  ?.allowOrganizationQrCodeEvaluationAtActivityEnd
              }
            />

            <label
              className="form-check-label"
              htmlFor="allowOrganizationQrCodeEvaluationAtActivityEnd"
            >
              Permitir avaliação do estudante via QR Code no final da atividade
            </label>
          </div>

          <div className="form-check mb-3">
            <Input
              id="appStudentAllowEvaluationAcceptanceByStudent"
              type="checkbox"
              name="setting.appStudentAllowEvaluationAcceptanceByStudent"
              className="form-check-input"
              onBlur={validation.handleBlur}
              onChange={validation.handleChange}
              checked={
                validation?.values?.setting
                  ?.appStudentAllowEvaluationAcceptanceByStudent
              }
            />

            <label
              className="form-check-label"
              htmlFor="appStudentAllowEvaluationAcceptanceByStudent"
            >
              Permitir aceite da avaliação pelo estudante
            </label>
          </div>
        </Col>

        <Col md={4} className={`${marginYButton}`}>
          <AppProfessionalSettingsSection validation={validation} />
        </Col>
      </Row>
    </>
  );
};
